import { render, staticRenderFns } from "./admin-company-invoice.vue?vue&type=template&id=60be1f44&scoped=true&"
import script from "./admin-company-invoice.ts?vue&type=script&lang=ts&"
export * from "./admin-company-invoice.ts?vue&type=script&lang=ts&"
import style0 from "./admin-company-invoice.vue?vue&type=style&index=0&id=60be1f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be1f44",
  null
  
)

export default component.exports